import { PhysicalHazard, StateOfMatter, UnitType } from "encamp-prisma/generated/browser";

/**
 * The unit a cross-unit chemical-merge combine converts amounts into for a
 * given facility. Most jurisdictions report Tier II amounts in pounds, but
 * some require (or strongly prefer) state-of-matter-specific units — CA/OR
 * report liquids in gallons and gases in cubic feet, SD reports liquids in
 * gallons, and AK reports compressed gases in cubic feet. Mirrors the
 * jurisdiction rules in encamp-compliance-engine's facilityChemicalUnitRules.
 * State-of-matter precedence follows that rule set: SOLID, then LIQUID, then
 * GAS; a chemical with none of them falls back to pounds.
 */
export function resolveCombineTargetUnit(
  state: string | null | undefined,
  stateOfMatter: readonly StateOfMatter[] | null | undefined,
  physicalHazards: readonly PhysicalHazard[] | null | undefined
): UnitType {
  const matters = stateOfMatter ?? [];
  if (state === "CA" || state === "OR") {
    if (matters.includes(StateOfMatter.SOLID)) return UnitType.POUNDS;
    if (matters.includes(StateOfMatter.LIQUID)) return UnitType.GALLONS;
    if (matters.includes(StateOfMatter.GAS)) return UnitType.CUBIC_FEET;
    return UnitType.POUNDS;
  }
  if (state === "SD") {
    if (matters.includes(StateOfMatter.LIQUID)) return UnitType.GALLONS;
    return UnitType.POUNDS;
  }
  if (state === "AK" && (physicalHazards ?? []).includes(PhysicalHazard.COMPRESSED_GAS)) {
    return UnitType.CUBIC_FEET;
  }
  return UnitType.POUNDS;
}
